import React, { Component } from 'react'
import { Row, Col, Nav, Card, Image, Tab, Form, Button, Container } from 'react-bootstrap'
import DateTime from 'react-datetime'
import BreadcrumbHeading from '../../breadcrumbs/BreadcrumbHeading'
import ResultAnalysisSection from '../../analysis/result_analysis/ResultAnalysisSection'
import PracticeExamAnalysisSection from '../../analysis/practice_exam_analysis/PracticeExamAnalysisSection'
import StrengthSection from '../../analysis/strength/StrengthSection'
import TimeAnalysisSection from '../../analysis/time_analysis/TimeAnalysisSection'
import ComplexityAnalysisSection from '../../analysis/complexity_analysis/ComplexityAnalysisSection'
import ErrorAnalysisSection from '../../analysis/error_analysis/ErrorAnalysisSection'
import QuestionTypeAnalysisSection from '../../analysis/question_type/QuestionTypeAnalysisSection';
import StudentSummaryReports from '../../analysis/studentPerformanceReport/studentPerformanceReport'

import '../../../../react-datetime.css'
import './_studentprofile.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";

import NAOverAllDetails from './non-academic_details/na_overall_details';
import NAOfflineMarksDetails from './non-academic_details/na_offlineMarks_details';
import NAAttendanceReports from './non-academic_details/na_attendanceReports';
import NAFeeDetails from './non-academic_details/na_fee_details';
import NAPermissionDetails from './non-academic_details/na_permission_details'
import StudentProfileEamcet from './studentProfileEamcet'

const GET_GLOBALS = gql`
 query($institution_id: Int!) {
          globals(institution_id: $institution_id) {
            globalBranches{
              id
              branch_name
            }
            globalSections{
              id
              section_name
            }
            classes{
              id
              class
            }
            b_e_c_s_data{
                branch_id
                exam_id
                class_id
                section_id
              }
              subjects{
                id
                subject
              }
              offlineExamSubjects{
                id
                subject
              }
              exams{
                id
                exam
                exam_subjects{
                    subject_id
                  }
            }
          }
        }
`;

export class StudentOrganizationProfileSection extends Component {
    constructor(props) {
        super(props)
        console.log("hislocationData", props.hislocationData);
        let index = "";
        let studentData = [];
        let type = "";

        if (props.hislocationData != undefined) {
            // let found = props.hislocationData.row.totalData.find(a => a.student_name === props.hislocationData.row.student_name);
            // let idindex = props.hislocationData.row.totalData.indexOf(found);
            // console.log("idindex", idindex);
            // index = idindex;
            studentData = props.hislocationData.row;
            type = props.hislocationData.type != undefined ? props.hislocationData.type : "academic"
        };

        this.state = {
            BreadcrumbData: {
                Title: 'Student Profile'
            },
            studentData: studentData,
            index: index,
            type: type,
            exam_type: "0,1",
            class_id: "1,2",
            exam_typevalue: { value: 2, label: 'ALL' },
            class_idvalue: { value: 0, label: 'ALL' },
            // defaultActiveKey: "first",
            defaultActiveKey:"eight",
            defaultActiveKey1: "n-a-first",
            marksSelectionType: 4,
            marksSelectionTypeObj: { value: 4, label: 'Overall' }

        }
    }

    handleSelectTimelineChange = (name, val) => {

        const selectionTimelines = [{ value: 1, label: "Last 30 Days" }, { value: 2, label: "Last 60 Days" }, { value: 3, label: "3 Months" }, { value: 4, label: "Overall" }]
        let selectionData = selectionTimelines.find((a) => a.value == val);

        this.setState({
            marksSelectionType: val, marksSelectionTypeObj: {
                value: selectionData.value,
                label: selectionData.label
            }
        })
    };

    selecthandleInputChange = (ename, evalue) => {
        console.log("selecthandleInputChange", ename, evalue);
        const name = ename;
        const value = evalue;
        if (name == "exam_type") {
            if (value == "0") {
                this.setState({
                    exam_typevalue: { value: value, label: 'Practise' },
                    exam_type: value
                });
            }
            else if (value == "1") {
                this.setState({
                    exam_typevalue: { value: value, label: 'Exam' },
                    exam_type: value
                });
            }
            else if (value == "2") {
                this.setState({
                    exam_typevalue: { value: value, label: 'ALL' },
                    exam_type: "0,1"
                });
            }

        }
        if (name == "class_id") {
            if (value == "0") {
                this.setState({
                    class_idvalue: { value: value, label: 'ALL' },
                    class_id: "1,2"
                });
            }
            else if (value == "1") {
                this.setState({
                    class_idvalue: { value: value, label: 'Class-XI' },
                    class_id: value
                });
            }
            else if (value == "2") {
                this.setState({
                    class_idvalue: { value: value, label: 'Class-XII' },
                    class_id: value
                });
            }
        }

        if (name == 'non-academic') {
            if (value == "0") {
                this.setState({
                    defaultActiveKey1: "n-a-second"
                });
            } else if (value == "1") {
                this.setState({
                    defaultActiveKey1: "n-a-third"
                });
            } else if (value == "2") {
                this.setState({
                    defaultActiveKey1: "n-a-fourth"
                });
            } else {
                this.setState({
                    defaultActiveKey1: "n-a-fifth"
                })
            }
        }
    }
    defaultActiveKeyFun = (e) => {
        console.log("defaultActiveKeyFun");
        this.setState({
            defaultActiveKey: "first"
        });

    }

    tabwisedefaultActiveKeyFun = (type) => {
        console.log("tabwisedefaultActiveKeyFun", type);
        this.setState({
            defaultActiveKey: type
        });

    }

    tabwisedefaultActiveKeyFun1 = (type) => {
        console.log("tabwisedefaultActiveKeyFun", type);
        this.setState({
            defaultActiveKey1: type
        });

    }
    eventKeyFunction = (type) => {
        console.log("eventKeyFunction");
        this.setState({ defaultActiveKey: type });
    }

    eventKeyFunction1 = (type) => {
        console.log("eventKeyFunction");
        this.setState({ defaultActiveKey1: type });
    }
    // leftarrowFun = (e) => {
    //     this.setState({ index: this.state.index - 1 });
    // }
    // rightarrowFun = (e) => {
    //     this.setState({ index: this.state.index + 1 });
    // }
    render() {

        console.log("prrrrrrrr", this.props)

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;
        if (loading1) return null;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        let data = [];
        let branchvalue = "";
        let classvalue = "";
        let sectionvalue = "";

        console.log("mahesh", this.props);
        // data = this.state.studentData[this.state.index];
        branchvalue = globals.globals.globalBranches.find((a) => a.id == this.state.studentData.branch_id);
        classvalue = globals.globals.classes.find((a) => a.id == this.state.studentData.class_id);
        sectionvalue = globals.globals.globalSections.find((a) => a.id == this.state.studentData.section_id);

        return (
            <>

                <div className="student-profile">

                    <Container fluid>
                        {/* <Row>
                            <Col xl={12} lg={12} md={12} sm={12} className='mt-3'>
                                <BreadcrumbHeading breadcrumbs={this.state.BreadcrumbData} />
                            </Col>
                        </Row> */}
                        
                        {
                            this.props.hislocationData.row.is_academic_exist == true &&
                                this.props.hislocationData.row.is_non_academic_exist == true ? (
                                this.state.type != "academic" ? (
                                    <Tab.Container id="left-tabs-example" activeKey={this.state.defaultActiveKey1}>
                                        <Card className="profile-card">
                                            <Card.Body>
                                                <div className="d-flex align-items-center mb-4">
                                                    {this.state.studentData.profile_pic != "" ? (<Image src={`http://neetjeeguru.com/files/${this.state.studentData.profile_pic}`} width="100" roundedCircle thumbnail alt="profile-img" />) : (
                                                        <Image src={require('../../../../images/businessman.png')} width="100" roundedCircle thumbnail alt="profile-img" />
                                                    )}

                                                    <div className="content ml-3">
                                                        <p>Student</p>
                                                        <h4>{this.state.studentData.student_name}</h4>
                                                        <p>Branch-{branchvalue.branch_name},
                                                            Class-{classvalue.class},
                                                            Section-{sectionvalue.section_name}</p>
                                                    </div>
                                                </div>

                                                <Row>
                                                    <Col>
                                                        <ul className='list-inline question_sel_cls'>
                                                            <li className={this.state.type == "academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "academic", defaultActiveKey: "first" }) }} >Academic</li>
                                                            <li className={this.state.type == "non-academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "non-academic", defaultActiveKey1: "n-a-first" }) }} >Non-Academic</li>
                                                        </ul>
                                                    </Col>
                                                </Row>

                                                <Nav variant="pills bg-white" className="flex-row">
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            onClick={(e) => this.eventKeyFunction1("n-a-first")}
                                                            eventKey="n-a-first"
                                                        >Overview</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            onClick={(e) => this.eventKeyFunction1("n-a-second")}
                                                            eventKey="n-a-second"
                                                        >Offline Marks</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            onClick={(e) => this.eventKeyFunction1("n-a-third")}
                                                            eventKey="n-a-third"

                                                        >Attendance Reports</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            onClick={(e) => this.eventKeyFunction1("n-a-fourth")}
                                                            eventKey="n-a-fourth"
                                                        >Fee Details</Nav.Link>
                                                    </Nav.Item>
                                                    {/* <Nav.Item>
        <Nav.Link
            onClick={(e) => this.eventKeyFunction1("n-a-fifth")}
            eventKey="n-a-fifth"
        >Permissions</Nav.Link>
    </Nav.Item> */}
                                                </Nav>
                                            </Card.Body>
                                        </Card>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="n-a-first">
                                                <NAOverAllDetails
                                                    tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                    mobile={this.state.studentData.contact_no}
                                                    seperationType="college"
                                                    stateData={this.state}
                                                    selecthandleInputChange={this.selecthandleInputChange}
                                                />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="n-a-second">
                                                <NAOfflineMarksDetails
                                                    tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                    mobile={this.state.studentData.contact_no}
                                                    seperationType="college"
                                                    stateData={this.state}
                                                    globals={this.props.globals.globals}
                                                    selecthandleInputChange={this.selecthandleInputChange}
                                                    handleSelectTimelineChange={this.handleSelectTimelineChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="n-a-third">
                                                <NAAttendanceReports
                                                    tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                    mobile={this.state.studentData.contact_no}
                                                    seperationType="college"
                                                    stateData={this.state}
                                                    selecthandleInputChange={this.selecthandleInputChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="n-a-fourth">
                                                <NAFeeDetails
                                                    tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                    mobile={this.state.studentData.contact_no}
                                                    seperationType="college"
                                                    stateData={this.state}
                                                    selecthandleInputChange={this.selecthandleInputChange}
                                                />
                                            </Tab.Pane>
                                            {/* <Tab.Pane eventKey="n-a-fifth">
<NAPermissionDetails
    tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
    stateData={this.state}
    selecthandleInputChange={this.selecthandleInputChange}
/>
</Tab.Pane> */}

                                        </Tab.Content>
                                    </Tab.Container>

                                ) : (
                                    <Tab.Container id="left-tabs-example" activeKey={this.state.defaultActiveKey}>
                                        <Card className="profile-card">
                                            <Card.Body>
                                                <div className="d-flex align-items-center mb-4">
                                                    {this.state.studentData.profile_pic != "" ? (<Image src={`http://neetjeeguru.com/files/${this.state.studentData.profile_pic}`} width="100" roundedCircle thumbnail alt="profile-img" />) : (
                                                        <Image src={require('../../../../images/businessman.png')} width="100" roundedCircle thumbnail alt="profile-img" />
                                                    )}

                                                    <div className="content ml-3">
                                                        <p>Student</p>
                                                        <h4>{this.state.studentData.student_name}</h4>
                                                        <p>Branch-{branchvalue.branch_name},
                                                            Class-{classvalue.class},
                                                            Section-{sectionvalue.section_name}</p>
                                                    </div>
                                                </div>

                                                <Row>
                                                    <Col>
                                                        <ul className='list-inline question_sel_cls'>
                                                            <li className={this.state.type == "academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "academic", defaultActiveKey: "first" }) }} >Academic</li>
                                                            <li className={this.state.type == "non-academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "non-academic", defaultActiveKey1: "n-a-first" }) }} >Non-Academic</li>
                                                        </ul>
                                                    </Col>
                                                </Row>
                                                {
                                                    this.props.hislocationData.row.exam_id != "1" && this.props.hislocationData.row.exam_id != "2" ? (
                                                        <StudentProfileEamcet
                                                            examId={this.props.hislocationData.row}
                                                        />
                                                    ) : (
                                                        <Nav variant="pills bg-white" className="flex-row">
                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("first")}
                                                                    eventKey="first"
                                                                >Overview</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("second")}
                                                                    eventKey="second"
                                                                >Practise &amp; Exams Analysis</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("third")}
                                                                    eventKey="third"

                                                                >Strength Analysis</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("four")}
                                                                    eventKey="four"
                                                                >Time Analysis</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("five")}
                                                                    eventKey="five"
                                                                >Complexity Analysis</Nav.Link>
                                                            </Nav.Item>

                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("seven")}
                                                                    eventKey="seven"
                                                                >Question Type Analysis</Nav.Link>
                                                            </Nav.Item>

                                                            <Nav.Item>
                                                                <Nav.Link
                                                                    onClick={(e) => this.eventKeyFunction("eight")}
                                                                    eventKey="eight"
                                                                >Performance Report</Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    )
                                                }

                                            </Card.Body>
                                        </Card>

                                        {
                                            this.props.hislocationData.row.exam_id != "1" && this.props.hislocationData.row.exam_id != "2" ? (
                                                ""
                                            ) : (
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <ResultAnalysisSection
                                                            tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun}
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange}
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <PracticeExamAnalysisSection
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="third">
                                                        <StrengthSection
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="four">
                                                        <TimeAnalysisSection
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="five">
                                                        <ComplexityAnalysisSection
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange}
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="seven">
                                                        <QuestionTypeAnalysisSection
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange} />
                                                    </Tab.Pane>

                                                    <Tab.Pane eventKey="eight">
                                                        <StudentSummaryReports
                                                            mobile={this.state.studentData.contact_no}
                                                            seperationType="college"
                                                            defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                            stateData={this.state}
                                                            selecthandleInputChange={this.selecthandleInputChange} />
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            )
                                        }

                                    </Tab.Container>
                                )
                            ) : this.props.hislocationData.row.is_non_academic_exist == true ? (
                                <Tab.Container id="left-tabs-example" activeKey={this.state.defaultActiveKey1}>
                                    <Card className="profile-card">
                                        <Card.Body>
                                            <div className="d-flex align-items-center mb-4">
                                                {this.state.studentData.profile_pic != "" ? (<Image src={`http://neetjeeguru.com/files/${this.state.studentData.profile_pic}`} width="100" roundedCircle thumbnail alt="profile-img" />) : (
                                                    <Image src={require('../../../../images/businessman.png')} width="100" roundedCircle thumbnail alt="profile-img" />
                                                )}

                                                <div className="content ml-3">
                                                    <p>Student</p>
                                                    <h4>{this.state.studentData.student_name}</h4>
                                                    <p>Branch-{branchvalue.branch_name},
                                                        Class-{classvalue.class},
                                                        Section-{sectionvalue.section_name}</p>
                                                </div>
                                            </div>

                                            <Row>
                                                <Col>
                                                    <ul className='list-inline question_sel_cls'>
                                                        {/* <li className={this.state.type == "academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "academic", defaultActiveKey: "first" }) }} >Academic</li> */}
                                                        <li className={this.state.type == "non-academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "non-academic", defaultActiveKey1: "n-a-first" }) }} >Non-Academic</li>
                                                    </ul>
                                                </Col>
                                            </Row>

                                            <Nav variant="pills bg-white" className="flex-row">
                                                <Nav.Item>
                                                    <Nav.Link
                                                        onClick={(e) => this.eventKeyFunction1("n-a-first")}
                                                        eventKey="n-a-first"
                                                    >Overview</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link
                                                        onClick={(e) => this.eventKeyFunction1("n-a-second")}
                                                        eventKey="n-a-second"
                                                    >Offline Marks</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link
                                                        onClick={(e) => this.eventKeyFunction1("n-a-third")}
                                                        eventKey="n-a-third"

                                                    >Attendance Reports</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link
                                                        onClick={(e) => this.eventKeyFunction1("n-a-fourth")}
                                                        eventKey="n-a-fourth"
                                                    >Fee Details</Nav.Link>
                                                </Nav.Item>
                                                {/* <Nav.Item>
<Nav.Link
    onClick={(e) => this.eventKeyFunction1("n-a-fifth")}
    eventKey="n-a-fifth"
>Permissions</Nav.Link>
</Nav.Item> */}
                                            </Nav>
                                        </Card.Body>
                                    </Card>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="n-a-first">
                                            <NAOverAllDetails
                                                tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                mobile={this.state.studentData.contact_no}
                                                seperationType="college"
                                                stateData={this.state}
                                                selecthandleInputChange={this.selecthandleInputChange}
                                            />
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="n-a-second">
                                            <NAOfflineMarksDetails
                                                tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                mobile={this.state.studentData.contact_no}
                                                seperationType="college"
                                                stateData={this.state}
                                                globals={this.props.globals.globals}
                                                selecthandleInputChange={this.selecthandleInputChange}
                                                handleSelectTimelineChange={this.handleSelectTimelineChange}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="n-a-third">
                                            <NAAttendanceReports
                                                tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                mobile={this.state.studentData.contact_no}
                                                seperationType="college"
                                                stateData={this.state}
                                                selecthandleInputChange={this.selecthandleInputChange}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="n-a-fourth">
                                            <NAFeeDetails
                                                tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                                mobile={this.state.studentData.contact_no}
                                                seperationType="college"
                                                stateData={this.state}
                                                selecthandleInputChange={this.selecthandleInputChange}
                                            />
                                        </Tab.Pane>
                                        {/* <Tab.Pane eventKey="n-a-fifth">
                                       <NAPermissionDetails
                                        tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun1}
                                        stateData={this.state}
                                        selecthandleInputChange={this.selecthandleInputChange}
                                        />
                                   </Tab.Pane> */}

                                    </Tab.Content>
                                </Tab.Container>
                            ) : (
                                <Tab.Container id="left-tabs-example" activeKey={this.state.defaultActiveKey}>
                                    <Card className="profile-card">
                                        <Card.Body>
                                            <div className="d-flex align-items-center mb-4">
                                                {this.state.studentData.profile_pic != "" ? (<Image src={`http://neetjeeguru.com/files/${this.state.studentData.profile_pic}`} width="100" roundedCircle thumbnail alt="profile-img" />) : (
                                                    <Image src={require('../../../../images/businessman.png')} width="100" roundedCircle thumbnail alt="profile-img" />
                                                )}

                                                <div className="content ml-3">
                                                    <p>Student</p>
                                                    <h4>{this.state.studentData.student_name}</h4>
                                                    <p>Branch-{branchvalue?.branch_name ?? "-"},
                                                        Class-{classvalue.class},
                                                        Section-{sectionvalue.section_name}</p>
                                                </div>
                                            </div>

                                            <Row>
                                                <Col>
                                                    <ul className='list-inline question_sel_cls'>
                                                        <li className={this.state.type == "academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "academic", defaultActiveKey: "first" }) }} >Academic</li>
                                                        {/* <li className={this.state.type == "non-academic" ? "active mr-4" : "mr-4"} onClick={() => { this.setState({ type: "non-academic", defaultActiveKey1: "n-a-first" }) }} >Non-Academic</li> */}
                                                    </ul>
                                                </Col>
                                            </Row>
                                            {
                                                this.props.hislocationData.row.exam_id != "1" && this.props.hislocationData.row.exam_id != "2" ? (
                                                    <StudentProfileEamcet
                                                        examId={this.props.hislocationData.row}
                                                    />
                                                ) : (
                                                    <Nav variant="pills bg-white" className="flex-row">
                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("first")}
                                                                eventKey="first"
                                                            >Overview</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("second")}
                                                                eventKey="second"
                                                            >Practise &amp; Exams Analysis</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("third")}
                                                                eventKey="third"

                                                            >Strength Analysis</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("four")}
                                                                eventKey="four"
                                                            >Time Analysis</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("five")}
                                                                eventKey="five"
                                                            >Complexity Analysis</Nav.Link>
                                                        </Nav.Item>

                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("seven")}
                                                                eventKey="seven"
                                                            >Question Type Analysis</Nav.Link>
                                                        </Nav.Item>

                                                        <Nav.Item>
                                                            <Nav.Link
                                                                onClick={(e) => this.eventKeyFunction("eight")}
                                                                eventKey="eight"
                                                            >Performance Report</Nav.Link>
                                                        </Nav.Item>
                                                    </Nav>
                                                )}
                                        </Card.Body>
                                    </Card>
                                    {
                                        this.props.hislocationData.row.exam_id != "1" && this.props.hislocationData.row.exam_id != "2" ? (
                                            ""
                                        ) : (
                                            <Tab.Content>
                                                <Tab.Pane eventKey="first">
                                                    <ResultAnalysisSection
                                                        tabwisedefaultActiveKeyFun={this.tabwisedefaultActiveKeyFun}
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange}
                                                    />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="second">
                                                    <PracticeExamAnalysisSection
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange} />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="third">
                                                    <StrengthSection
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange} />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="four">
                                                    <TimeAnalysisSection
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange} />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="five">
                                                    <ComplexityAnalysisSection
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange}
                                                    />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="seven">
                                                    <QuestionTypeAnalysisSection
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                        selecthandleInputChange={this.selecthandleInputChange} />
                                                </Tab.Pane>

                                                <Tab.Pane eventKey="eight">
                                                    <StudentSummaryReports
                                                        mobile={this.state.studentData.contact_no}
                                                        seperationType="college"
                                                        defaultActiveKeyFun={this.defaultActiveKeyFun}
                                                        stateData={this.state}
                                                    // selecthandleInputChange={this.selecthandleInputChange} 
                                                    />
                                                </Tab.Pane>
                                            </Tab.Content>
                                        )
                                    }
                                </Tab.Container>
                            )
                        }
                    </Container>
                </div>
            </>

        )
    }
}


export default withRouter(
    compose(
        graphql(
            GET_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "globals"
            }
        )
    )(StudentOrganizationProfileSection)
);
